const onLogout = () => {
    document.cookie = 'student-dashboard-grade= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    localStorage.removeItem('passwordConfirmedToken');
    localStorage.removeItem('passwordConfirmedTokenExpiry');

    const shouldRedirectToProductSelection = sessionStorage.getItem('shouldRedirectToProductSelection');

    if (shouldRedirectToProductSelection === 'true') {
        sessionStorage.setItem('postLogoutRedirect', window.config.PRODUCT_SELECTION_URL);
    }

    sessionStorage.removeItem('shouldRedirectToProductSelection');
};

export default onLogout;
